import { asyncRoutes, constantRoutes } from '@/router'
import linq from 'linq'

import Layout from '@/layout'
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route, isadmin) {
    if (isadmin === true) {
        return true
    }
    if (route.children && route.children.length > 0) {
        return true
    }
    if (route.name && route.meta.title) {
        return linq.from(roles).any((role) => {
            // console.log('role', role)
            return route.name === role.Tablekey && role.CanView === true
        })
    } else {
        return true
    }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
export function filterAsyncRoutes(routes, roles, isadmin) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }
    if (hasPermission(roles, tmp, isadmin)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles, isadmin)
      }
      res.push(tmp)
    }
  })

  return res
}

const state = {
  routes: [],
  addRoutes: [],
  forms: [],
  pdabills: []
}

const mutations = {
    SET_ROUTES: (state, routes) => {
        routes = linq.from(routes).where(p => p.children === undefined || p.children.length > 0).toArray()
        state.addRoutes = routes
        console.log('routes', routes)
        console.log('constantRoutes', constantRoutes)
        let root = linq.from(constantRoutes).where(p => p.path === '/').firstOrDefault()
        if (root && routes.length > 0) {
            const menu = routes[0]
            if (menu && menu.children && menu.children.length > 0) {
                root.redirect = menu.path + '/' + menu.children[0].path
            }
        }

        state.routes = constantRoutes.concat(routes)
    },
    SET_FORMS: (state, forms) => {
        console.log('forms', forms)
        state.forms = forms
    }
}

const actions = {
  generateRoutes({ commit }, { roles, forms, pdabills, isadmin }) {
    return new Promise(resolve => {
        let accessedRoutes = []
        let viewRoutes = asyncRoutes
        for (let i = 0; i < forms.length; i++) {
            viewRoutes.push({
                alwaysShow: true,
                component: Layout,
                children: linq.from(forms[i].children).select(p => {
                    return {
                        component: () => import('@/views/OA/OABill.vue'),
                        meta: {
                            title: p.formName,
                            icon: JSON.parse(p.logo).icon,
                            formId: p.formId
                        },
                        name: p.formId,
                        path: `/${forms[i].name}/${p.formName}`,
                        hidden: false,
                    }
                }).toArray(),
                name: 'form_' + forms[i].id,
                path: '/' + forms[i].name,
                meta: {
                    title: forms[i].name,
                },
                hidden: false
            })
        }
        const hep2router = linq.from(viewRoutes).firstOrDefault(p => p.path === '/hep2', null)
        if (hep2router) {
            for (let i = 0; i < pdabills.length; i++) {
                try {
                    const config = JSON.parse(pdabills[i].Config)
                    hep2router.children.push({
                        component: () => import('@/views/hep2/HEP2PDA-Back.vue'),
                        meta: {
                            title: pdabills[i].Name,
                            billid: pdabills[i].ID,
                            noCache: false,
                            color: config.IconColor || '#409EFF',
                            icon: config.Icon || 'el-icon-document',
                        },
                        name: pdabills[i].Name,
                        path: `/${pdabills[i].Name}`,
                        hidden: false,
                    })
                }
                catch (e) {
                    console.error('Error parsing config for pdabill', pdabills[i], e)
                }
            }
        }
        if (roles.includes('admin')) {
            accessedRoutes = viewRoutes || []
        } else {
            accessedRoutes = filterAsyncRoutes(viewRoutes, roles, isadmin)
        }
        commit('SET_ROUTES', accessedRoutes)
        commit('SET_FORMS', forms)
        console.log('accessedRoutes', accessedRoutes)
        resolve(accessedRoutes)
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
